<template>
  <div>
    <a-form class="simiot-nested-search-form" :form="form" @submit="handleSearch">
      <a-row :gutter="24">
        <a-col :span="8" :xxl="6">
          <a-form-item label="CPE型号">
            <a-select
              v-decorator="['cpe_model_id']"
              allow-clear
              show-search
              option-filter-prop="children"
              placeholder="请选择"
              :loading="loadingCpeModelOptions"
            >
              <a-select-option
                v-for="opt in cpeModelOptions"
                :key="opt.id"
                :value="opt.id"
              >
                {{ formatModelOption(opt) }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item label="通信制式">
            <a-select
              v-decorator="['comm_mode_id']"
              allow-clear
              show-search
              option-filter-prop="children"
              placeholder="请选择"
              :loading="loadingCommModeOptions"
            >
              <a-select-option
                v-for="opt in commModeOptions"
                :key="opt.id"
                :value="opt.id"
              >
                {{ opt.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item label="供应商">
            <a-select
              v-decorator="['cpe_supplier_id']"
              allow-clear
              show-search
              option-filter-prop="children"
              placeholder="请选择"
              :loading="loadingSupplierOptions"
            >
              <a-select-option
                v-for="opt in supplierOptions"
                :key="opt.id"
                :value="opt.id"
              >
                {{ opt.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item label="SN">
            <a-input
              v-decorator="['sn', { normalize: this.$lodash.trim }]"
              allow-clear
              placeholder="支持模糊搜索"
            />
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item label="采购批次">
            <a-input
              v-decorator="['purchase_batch', { normalize: this.$lodash.trim }]"
              allow-clear
              placeholder="支持模糊搜索"
            />
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item label="单价低于">
            <a-input-number
              v-decorator="['unit_price_lt']"
              :min="0"
              :precision="2"
              :step="0.01"
              style="width: 100%"
              placeholder="留空表示不限"
            />
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item>
            <a-space>
              <a-button type="primary" html-type="submit">
                搜索
              </a-button>
              <a-button @click="handleReset">
                刷新
              </a-button>
            </a-space>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import { findCommonTypeOptions } from '@/api/common_type'
import { findCpeSuppliers } from '@/api/cpe_supplier'
import { findCpeSupplierModelOptions } from '@/api/cpe_supplier_model'

export default {
  name: 'SearchCpeInventory',
  data() {
    return {
      form: this.$form.createForm(this, { name: 'cpe_inventory_search' }),
      cpeModelOptions: [],
      commModeOptions: [],
      supplierOptions: [],
      loadingCpeModelOptions: false,
      loadingCommModeOptions: false,
      loadingSupplierOptions: false
    }
  },
  created() {
    this.fetchCpeModelOptions()
    this.fetchCommModeOptions()
    this.fetchSupplierOptions()
  },
  methods: {
    formatModelOption(opt) {
      if (opt.display_model && opt.display_model !== opt.purchase_model) {
        return `${opt.purchase_model}（对外：${opt.display_model}）`
      }
      return opt.purchase_model || opt.name
    },

    fetchCpeModelOptions() {
      this.loadingCpeModelOptions = true
      findCpeSupplierModelOptions({}).then((res) => {
        if (res.code === 0) {
          this.cpeModelOptions = res.data
        }
        this.loadingCpeModelOptions = false
      })
    },

    fetchCommModeOptions() {
      this.loadingCommModeOptions = true
      findCommonTypeOptions('product_comm_mode').then((res) => {
        if (res.code === 0) {
          this.commModeOptions = res.data
        }
        this.loadingCommModeOptions = false
      })
    },

    fetchSupplierOptions() {
      this.loadingSupplierOptions = true
      findCpeSuppliers({ page: 1, per_page: 500 }).then((res) => {
        if (res.code === 0) {
          this.supplierOptions = res.data
        }
        this.loadingSupplierOptions = false
      })
    },

    handleSearch(e) {
      e.preventDefault()
      const v = this.form.getFieldsValue()
      const payload = {
        ...v,
        unit_price_lt: v.unit_price_lt != null && v.unit_price_lt !== '' ? v.unit_price_lt : undefined
      }
      this.$emit('submit', payload)
    },

    handleReset() {
      this.form.resetFields()
      this.$emit('submit', {})
    }
  }
}
</script>
